import { isActionRelevant } from './utils'
import { types } from 'store/Address'

/**
 * Lob returns their "invalid address" messages as a 200 with the invalid
 * reason. If we get an "invalid address" response, this middleware converts the
 * VERIFY_ADDRESS_SUCCESS into a VERIFY_ADDRESS_ERROR so we can display it as an
 * error message in the app.
 *
 * @returns Next action
 */
export const handleAddressVerification = () => next => action => {
  // Skip everything except the verify address endpoint
  const relevantActions = /VERIFY_ADDRESS_SUCCESS/
  if (!isActionRelevant(action, relevantActions)) return next(action)

  // Figure out which error message to show (if any) based on the reason
  // Lob provides
  let failMessage = ''
  if (/undeliverable/.test(action.payload.deliverability)) {
    failMessage = 'USPS cannot deliver to this address'
  } else if (/deliverable_missing_unit/.test(action.payload.deliverability)) {
    failMessage = 'Missing unit number'
  } else if (/deliverable_incorrect_unit/.test(action.payload.deliverability)) {
    failMessage = 'Incorrect unit number'
  } else if (
    /deliverable_unnecessary_unit/.test(action.payload.deliverability)
  ) {
    failMessage = 'Unnecessary unit number'
  }

  // If there is a failure reason, update the type.
  // Otherwise keep the VERIFY_ADDRESS_SUCCESS as is.
  if (failMessage) {
    action.type = types.VERIFY_ADDRESS_ERROR
    action.payload = {
      response: {
        message: failMessage,
      },
    }
    action.error = true
  }

  return next(action)
}
